export default __webpack_public_path__ + "static/media/ic_email_document.f0610d86.svg";